<template>
  <div data-cy="main-layout">
    <app-navigation></app-navigation>
    <app-bar :loading="$ui.isLoading"></app-bar>

    <v-main>
      <app-main-prepend></app-main-prepend>
      <router-view/>
    </v-main>
  </div>
</template>

<script>
import AppNavigation from '@/views/Layout/AppNavigation'
import AppBar from '@/views/Layout/AppBar'
import AppMainPrepend from '@/views/Layout/AppMainPrepend'
import Alert from '@/plugins/common/account/Components/Shared/Alert.vue'

export default {
  name: 'MainLayout',
  components: {Alert, AppMainPrepend, AppBar, AppNavigation}
}
</script>

<style scoped>

</style>